export default __webpack_public_path__ + "static/media/pulse.42dc3930.svg";